import axios from "axios";
import { useEffect } from "react";
import { apiServicesUrl } from "../services/baseUrl";
import { useNavigate } from "react-router-dom";
import { setSecureData, userAccessToken, userRefreshToken } from "../helpers";
import { setAccessToken, setRefreshToken } from "../Session";

const useAuthTokenRefresher = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkAndRefreshToken = async () => {
      const accessToken = userAccessToken();
      const refreshToken = userRefreshToken();

      if (!accessToken || !refreshToken) {
        return; // No tokens, no need to refresh
      }

      let exp;
      try {
        const payload = JSON.parse(atob(accessToken.split(".")[1])); // Decode JWT payload
        exp = payload?.exp;
        if (!exp) {
          console.error("Invalid JWT: Missing exp field");
          return;
        }
      } catch (error) {
        console.error("Failed to parse JWT token", error);
        return;
      }

      const currentTime = Math.floor(Date.now() / 1000);
      // Check if the token is about to expire in the next 30 minutes (1800 seconds)
      
      if (exp - currentTime < 1800) {
        try {
          const response = await axios.post(
            `${apiServicesUrl}/users/refresh-token`,
            {
              refresh_token: refreshToken,
            }
          );

          const data = response.data;
          if (data?.access_token && data?.refresh_token) {
            await setSecureData("accessToken", data.access_token);
            await setSecureData("refreshToken", data.refresh_token);
            setAccessToken(data.access_token);
            setRefreshToken(data.refresh_token);
          } else {            
            console.error("Invalid token data received", data);
            navigate("/login", { replace: true }); // Redirect to login page if tokens are invalid
          }
        } catch (error) {
          console.error("Failed to refresh token", error);
          navigate("/login", { replace: true }); // Redirect to login page if tokens are invalid
        }
      }
    };

    checkAndRefreshToken();
  }, [navigate]);

  return null; // This hook does not return anything
};

export default useAuthTokenRefresher;
